module.exports = __webpack_public_path__ + "static/headshot-henry-stamerjohan-2x.53ee6784.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-henry-stamerjohan-2x.jpg
// module id = 522
// module chunks = 152909308826437